import axios from "axios";
import {importRevenue} from '../_constants/api.constant'
// called without an Authorization header
export async function GetImportStatus(importId){
    const response=await axios.get(
        importRevenue.STATUS + importId + '/'
        ).then(function(response) {
        return response;
        }).catch(function (error) {
        // handle error
        console.log(error);
        console.log(error.response);
        return error.response;
        });
    return response;
}
